import { Link } from 'react-router-dom';
import type { AuctionCard } from '@/types/domain';
import { formatMoney, formatTimeLeftCompact } from '@/lib/format';
import { haptic } from '@/lib/telegram';
import { useCountdown } from '@/hooks/useCountdown';
import { Tag } from '@/components/ui/Tag';
import styles from './AuctionRow.module.css';

interface Props {
  auction: AuctionCard;
}

export const AuctionRow = ({ auction }: Props) => {
  const t = useCountdown(auction.ends_at);
  const isOver = t.isOver || auction.status !== 'active';

  return (
    <Link
      to={`/auction/${auction.id}`}
      className={styles.row}
      onClick={() => haptic.light()}
    >
      {auction.cover_photo ? (
        <img
          src={auction.cover_photo.url_thumb}
          alt=""
          className={styles.thumb}
          loading="lazy"
        />
      ) : (
        <div className={`${styles.thumb} ${styles.thumbPlaceholder}`}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="9" cy="9" r="2" />
            <path d="m21 15-5-5L5 21" />
          </svg>
        </div>
      )}

      <div className={styles.body}>
        <p className={styles.title}>{auction.title}</p>

        <div className={styles.metaRow}>
          {auction.tags[0] && <Tag variant="subtle">{auction.tags[0].name_ru}</Tag>}
          <span className={styles.metaText}>{auction.bids_count} ставок</span>
        </div>

        <div className={styles.bottom}>
          <span className={styles.price}>{formatMoney(auction.current_price)}</span>
          <span className={isOver ? styles.timeOver : styles.time}>
            {isOver ? statusLabel(auction.status) : formatTimeLeftCompact(auction.ends_at)}
          </span>
        </div>
      </div>
    </Link>
  );
};

const statusLabel = (s: string): string => {
  const map: Record<string, string> = {
    sold: 'Продан',
    unsold: 'Не продан',
    cancelled: 'Отменён',
    pending_review: 'На модерации',
    rejected: 'Отклонён',
    draft: 'Черновик',
  };
  return map[s] ?? s;
};